import { Component, Input } from '@angular/core';

import { VersionFeedbackMessage } from '@core/models/version-feedback-message';


@Component({
    selector: 'core-message-feedback',
    templateUrl: './message-feedback.component.html',
    styleUrls: ['./message-feedback.component.scss']
})
export class MessageFeedbackComponent {
    
    @Input() message: VersionFeedbackMessage;
    
}
